import * as fromDatatype from '../datatype-library';

export interface bl_cms_post_comments_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  post_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  comment_level: fromDatatype.IntegerDatatypeInterface;
  comment_string: fromDatatype.VarcharArrayDatatypeInterface;
  comment_type: fromDatatype.VarcharArrayDatatypeInterface;
  emoji_no: fromDatatype.IntegerDatatypeInterface;
  emoji_json: fromDatatype.JsonDatatypeInterface;
  mention_no: fromDatatype.IntegerDatatypeClass;
  website_url: fromDatatype.VarcharArrayDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharArrayDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_post_comments_hdr_RowClass implements bl_cms_post_comments_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  post_guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  comment_level: fromDatatype.IntegerDatatypeInterface;
  comment_string: fromDatatype.VarcharArrayDatatypeInterface;
  comment_type: fromDatatype.VarcharArrayDatatypeInterface;
  emoji_no: fromDatatype.IntegerDatatypeInterface;
  emoji_json: fromDatatype.JsonDatatypeInterface;
  mention_no: fromDatatype.IntegerDatatypeClass;
  website_url: fromDatatype.VarcharArrayDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharArrayDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
